<ng-container *ngIf="isMobile; else desktopTemplate">
  <div class="container-mobile">
    <div class="go-back" (click)="goback()">
      <fa-icon [icon]="getFaIcon('faChevronLeft')"></fa-icon>
      <span>Retour</span>
    </div>
    <div class="title">{{ notice?.title }}</div>
    <div class="content" [innerHTML]="notice?.content"></div>
    <div class="image" [innerHTML]="notice?.thumbImage"></div>
    <div class="action">
      <a [href]="notice?.linkUrl" target="_blank" class="action-link">
        <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
        <span>{{ notice?.linkLabel || notice?.linkUrl }}</span>
      </a>
    </div>
  </div>
</ng-container>
<ng-template #desktopTemplate>
  <div class="container">
    <div class="image">
      <div class="image-content" [innerHTML]="notice?.thumbImage"></div>
    </div>
    <mat-divider class="divider"></mat-divider>
    <div class="content-details">
      <div class="go-back" (click)="goback()">
        <fa-icon [icon]="getFaIcon('faChevronLeft')"></fa-icon>
        <span>Retour</span>
      </div>
      <div class="title">{{ notice?.title }}</div>
      <div class="content" [innerHTML]="notice?.content"></div>
      <div class="action">
        <a [href]="notice?.linkUrl" target="_blank" class="action-link">
          <fa-icon [icon]="getFaIcon('faExternalLinkAlt')"></fa-icon>
          <span>{{ notice?.linkLabel || notice?.linkUrl }}</span>
        </a>
      </div>
    </div>
  </div>
</ng-template>
